import React from 'react';
import Document from '../../_CustomComponents/DocumentV2';
import { connect } from "react-redux";
import BaseDocument from '../../_CustomComponents/BaseDocument';
import * as fileCrud from '../../../../crud/file.crud';
import { Alert } from "react-bootstrap";
import BiDynamicForm from '../../../../partials/layout/BiDynamicForm';
import { Validator, CustomRule, } from 'devextreme-react/validator';
import { CheckBox } from 'devextreme-react/check-box';
import moment from 'moment';
import { addDays } from 'date-fns';
import { FormattedMessage, injectIntl } from "react-intl";
import DocumentDraftInfo from '../../_CustomComponents/DocumentDraftInfo';





class ReplyDocument extends BaseDocument {
    constructor(props) {
        super(props);
        const { replyFields } = this.props.workflowItem;

        this.replyFormConfig = {
            fields: []
        };
        if (replyFields.ReplyStatus.visible) {
            this.replyFormConfig.fields.push(
                { label: replyFields.ReplyStatus.label, dataField: 'quoterequired', editorType: 'dxSelectBox', editorOptions: { dataSource: replyFields.ReplyStatus.replyOptions, valueExpr: 'value', displayExpr: 'display' } }
            );
        }

        if (replyFields.ReplyComment.visible) {
            this.replyFormConfig.fields.push(
                { label: replyFields.ReplyComment.label, dataField: 'eventcomment', editorType: 'dxHtmlEditor' }
            );
        }

    }



    renderForm = () => {
        return (
            <>
                <BiDynamicForm
                    isReply={true}
                    item={this.props.reply}
                    config={this.replyFormConfig}
                    valueChangeHandler={this.props.fieldChanged}
                    customFields={(this.props.customFields || {}).REPLY}
                />
            </>
        );
    }
    uploadFile = (data, config) => {
        const { companyid, projectid, contractid } = this.props.contract;
        const { documentType } = this.props.workflowItem.config;
        return fileCrud.uploadContractNotificationFiles(companyid, projectid, contractid, documentType + 'Reply', this.props.notification.compensationeventid, this.props.workflowItem.id, this.props.workflowItem.config.quotationWorkflowID, data, config)
    }
    render() {

        const documentIsFinal = !this.props.isAwaitingReply;
        const { replycreatebyname, replycreatedate, draftreplyby, draftreplydate, draftreplyto } = this.props.notification;

        const { documentType } = this.props.workflowItem.config;
        return (
            <>
                <DocumentDraftInfo
                    documentIsFinal={documentIsFinal}
                    createbyname={replycreatebyname}
                    createdate={replycreatedate}
                    lastdraftedbyname={draftreplyby}
                    lastdrafteddate={draftreplydate}
                    lastdraftednotifiedtoname={draftreplyto}
                    isReply={true}
                />
                <Document
                    key={documentIsFinal}
                    docConfig={this.props.notification.pdfreplyjsoncontent}
                    isFinal={documentIsFinal}
                    printDivRef={this.props.printDivRef}
                    workflowItem={this.props.workflowItem}
                    contract={this.props.contract}
                    reference={this.props.notification.referenceid}
                    form={documentIsFinal ? null : this.renderForm()}
                    uploadMethod={documentIsFinal ? null : this.uploadFile}
                    files={this.props.files}
                    notificationid={this.props.notificationid}
                    documentType={documentType}
                    isReply={true}
                    customFields={(this.props.customFields || {}).REPLY}
                    customFieldValues={this.props.notification.customfieldvalues}
                    assetid={this.props.notification.assetid}
                    saving={this.props.saving}
                    onFileUploadFinish={this.props.onFileUploadFinish}
                    onFileUploadStart={this.props.onFileUploadStart}
                />
            </>
        );
    }
}

const mapStateToProps = store => ({
    // globalResources: store.contract.template.resources,
});

export default injectIntl(connect(mapStateToProps)(ReplyDocument));
